





















































































































































































import Vue from 'vue';
import moment from 'moment';

import { mapActions, mapGetters } from 'vuex';
import { ExtractVue } from '@/utils/mixins';

import {
  IItemCommercialTranslation,
  ItemCommercialTranslation
} from '@/models';
import { ErrorManager } from '@/models/error';

import CommercialTranslationDetailFormDialog from '@/components/translation/CommercialTranslationDetailFormDialog.vue';
import CommercialTranslationUploadFileDialog from '@/components/translation/CommercialTranslationUploadFileDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import { IFetchItemCommercialTranslationActionPayload } from '@/store/itemcommercialtranslation';
import ALPage from '@/components/core/Page/ALPage.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';

import { createDownloadFile } from '@/utils/helpers';

// To extend the current type of VueComponent
// e.g this.$refs.commercialTranslationDetailFormDialog
interface Options extends InstanceType<typeof Vue> {
  $refs: {
    itemCommercialTranslationDetailFormDialog: ExtractVue<
      typeof CommercialTranslationDetailFormDialog
    >;
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  name: 'ItemCommercialTranslationListPage',

  components: {
    CommercialTranslationDetailFormDialog,
    CommercialTranslationUploadFileDialog,
    ConfirmationDialog,
    ALPage,
    ErrorAlert
  },

  data: () => ({
    loading: false,
    sortBy: 'id',
    sortDesc: true,
    search: '',
    headers: [
      { text: '', value: 'manually_created', sortable: false, width: 50 },
      { text: 'Identifier', value: 'identifier', sortable: false },
      { text: 'Language', value: 'language', sortable: false },
      { text: 'Language Code', value: 'language_code', sortable: false },
      {
        text: 'Language Description',
        value: 'language_description',
        sortable: false
      },
      { text: 'Description', value: 'text', sortable: false },
      { text: '', value: 'actions', align: 'center', sortable: false }
    ],

    deleteDialog: false,
    deleteInProgress: false,

    options: {
      showFirstLastPage: true,
      itemsPerPageOptions: [100]
    },
    page: 1,
    errorMessage: '',
    detailErrorMessage: '',
    selectedCommercialTranslation: null as null | ItemCommercialTranslation
  }),

  mounted() {
    this.fetchItemCommercialResults();
  },

  watch: {
    search(newSearch: string, prevSearch: string) {
      if (newSearch !== prevSearch) {
        this.page = 1; //called fetcdata
        this.fetchItemCommercialResults();
      }
    },
    page: {
      handler() {
        this.fetchItemCommercialResults();
      }
    }
  },

  computed: {
    ...mapGetters({
      itemCommercialTranslations:
        'itemCommercialTranslation/getItemCommercialTranslations',
      itemCount: 'itemCommercialTranslation/getItemCount'
    }),

    errorOccurred(): boolean {
      return this.errorMessage.length > 0;
    }
  },
  methods: {
    moment,

    ...mapActions({
      fetchItemCommercialTranslations:
        'itemCommercialTranslation/fetchItemCommercialTranslations',
      deleteItemCommercialTranslation:
        'itemCommercialTranslation/deleteItemCommercialTranslation',
      exportItemCommercialTranslations:
        'itemCommercialTranslation/exportItemCommercialTranslations'
    }),

    fetchItemCommercialResults() {
      this.loading = true;

      const params = {
        page: this.page
      } as IFetchItemCommercialTranslationActionPayload;

      if (this.search) {
        params.search = this.search;
      }

      this.fetchItemCommercialTranslations(params)
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.loading = false));
    },

    exportItemCommercialTranslationsList() {
      this.clearAllErrors();
      this.loading = true;
      this.exportItemCommercialTranslations()
        .then((data: Blob) => {
          createDownloadFile(
            data,
            `items-commercial-translations-${moment(new Date()).format(
              'YYYY-MM-DD-HH-mm-ss'
            )}.xlsx`
          );
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    createItemCommercialTranslation() {
      this.$refs.itemCommercialTranslationDetailFormDialog.open();
    },

    editItemCommercialTranslation(
      commercialTranslation: IItemCommercialTranslation
    ) {
      this.$refs.itemCommercialTranslationDetailFormDialog.open(
        commercialTranslation,
        true
      );
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    removeItemCommercialTranslation(
      commercialTranslation: IItemCommercialTranslation
    ) {
      this.clearAllErrors();
      this.deleteInProgress = true;

      this.deleteItemCommercialTranslation(commercialTranslation.id)
        .then(() => {
          this.deleteDialog = false;
        })
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }
        })
        .finally(() => {
          this.deleteInProgress = false;
        });
    },

    cancelItemCommercialTranslationDeleteDialog() {
      this.clearAllErrors();
      this.selectedCommercialTranslation = null;
      this.deleteDialog = false;
    },

    openItemCommercialTranslationDeleteDialog(
      itemCommercialTranslation: IItemCommercialTranslation
    ) {
      this.selectedCommercialTranslation = new ItemCommercialTranslation(
        itemCommercialTranslation
      );
      this.deleteDialog = true;
    }
  }
});
